import { isEnclosingTag } from './enclosing-tags';
import type { EnclosingTag } from './enclosing-tags';

/** Editor-authored attribute holding the tag, flattened per device resolution. */
export const ENCLOSING_TAG_ATTRIBUTE = 'enclosing-tag-3-resolutions';

/**
 * The single source of truth for which tag RText will render.
 *
 * Both the component and `resolveNoContainer` go through here: if they
 * disagreed, widget-react would wrap a block element in a redundant div or
 * hand box styles to an inline element that ignores them.
 *
 * The editor-authored attribute wins over the caller's prop. Attribute values
 * are untyped, so an unrecognised value falls back to the prop, then to no
 * enclosing tag at all.
 */
export function resolveEnclosingTag(
  componentAttributes?: { [key: string]: any },
  fallback?: EnclosingTag
): EnclosingTag | undefined {
  const userAssignedTag = componentAttributes?.[ENCLOSING_TAG_ATTRIBUTE];
  return isEnclosingTag(userAssignedTag) ? userAssignedTag : fallback;
}
